import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { IDocument, IDocumentCategory } from "../models/document-id";

@Injectable({
  providedIn: "root",
})
export class DocumentsService {
  public baseUrl: string = "/document";
  public list: any = [];
  public myDocumentList: any = [];
  public categoriesList: any = [];
  private baseurlCategories: string = "/document-category";
  public document_status_send: any = [
    {
      color: "warning",
      label: "PENDING",
    },
    {
      color: "info",
      label: "CREATING",
    },
    {
      color: "success",
      label: "COMPLETED",
    },
    {
      color: "danger",
      label: "ERROR_SEND",
    },
  ];

  public documents_statuses_acception: any = [
    {
      value: 0,
      color: "warning",
      label: "NOT_VIEWED",
    },
    {
      value: 1,
      color: "success",
      label: "VIEWED",
    },
    {
      value: 3,
      color: "secondary",
      label: "NOT_REQUIRED_VIEW",
    },
  ];

  public documents_statuses_signatures: any = [
    {
      value: 0,
      label: "NOT_SIGNED",
    },
    {
      value: 1,
      label: "SIGNED",
    },
    {
      value: 3,
      label: "NOT_REQUIRED_SIGNATURE",
    },
  ];

  public document_status_signature_sended: any = [
    {
      color: "warning",
      label: "SIGNATURE_TO_APPROVE",
    },
    {
      color: "success",
      label: "APPROVED",
    },
    {
      color: "danger",
      label: "REJECTED",
    },
  ];

  public fieldList: { translate: string; label: string }[] = [
    {
      translate: "USER_OFFICE_EMAIL",
      label: "USER_EMAIL",
    },
    {
      translate: "JOB_SITE",
      label: "USER_SITE",
    },
    {
      translate: "PROFESSIONAL_FIGURE",
      label: "USER_FIGURE",
    },
    {
      translate: "WORKING_CITY",
      label: "USER_WORKING_CITY",
    },
    {
      translate: "FIRSTNAME",
      label: "USER_FIRSTNAME",
    },
    {
      translate: "LASTNAME",
      label: "USER_LASTNAME",
    },
    {
      translate: "GENDER",
      label: "USER_SEX",
    },
    {
      translate: "BIRTHDAY",
      label: "USER_BIRTHDAY",
    },
    {
      translate: "DEPARTMENT",
      label: "USER_DEPARTMENT",
    },
    {
      translate: "EDUCATION_TITLE",
      label: "USER_EDUCATION_TITLE",
    },
    {
      translate: "EDUCATION_SUBJECT",
      label: "USER_EDUCATION_SUBJECT",
    },
    {
      translate: "EDUCATION_VOTE",
      label: "USER_EDUCATION_VOTE",
    },
    {
      translate: "HR_REFERENCE",
      label: "USER_HR_NAME",
    },
    {
      translate: "BIRTH_PLACE",
      label: "USER_BIRTH_PLACE",
    },
    {
      translate: "PRIVATE_PHONE",
      label: "USER_PRIVATE_PHONE",
    },
    {
      translate: "PRIVATE_EMAIL",
      label: "USER_PRIVATE_EMAIL",
    },
    {
      translate: "CIVIL_STATUS",
      label: "USER_CIVIL_STATUS",
    },
    {
      translate: "CHILD_NUMBER",
      label: "USER_CHILD_NUMBER",
    },
    {
      translate: "NATIONALITY",
      label: "USER_NATIONALITY",
    },
    {
      translate: "FISCAL_CODE",
      label: "USER_FISCAL_CODE",
    },
    {
      translate: "IBAN",
      label: "USER_IBAN",
    },
    {
      translate: "VAT_NUMBER",
      label: "USER_VAT_NUMBER",
    },
    {
      translate: "FIRSTNAME_EMERGENCY_CONTACT",
      label: "USER_EMERGENCY_CONTACT_FIRSTNAME",
    },
    {
      translate: "LASTNAME_EMERGENCY_CONTACT",
      label: "USER_EMERGENCY_CONTACT_LASTNAME",
    },
    {
      translate: "NUMBER_EMERGENCY_CONTACT",
      label: "USER_EMERGENCY_CONTACT_PHONE",
    },
    {
      translate: "NUMBER_ABSENCES_HOLIDAYS",
      label: "USER_RESIDUAL_HOLIDAYS",
    },
    {
      translate: "CITY",
      label: "ADDRESS_CITY",
    },
    {
      translate: "ADDRESS_PROVINCE",
      label: "ADDRESS_PROVINCE",
    },
    {
      translate: "ZIP_CODE",
      label: "ADDRESS_ZIPCODE",
    },
    {
      translate: "CORPORATE_SIGNATURE",
      label: "FIRMA_AZIENDALE",
    },
    {
      translate: "RESIDENCE_COMPLETE_ADDRESS",
      label: "ADDRESS_COMPLETE",
    },
    {
      translate: "CONTRACT_START_DATE",
      label: "CONTRACT_START_DATE",
    },
    {
      translate: "CONTRACT_END_DATE",
      label: "CONTRACT_END_DATE",
    },
    {
      translate: "CONTRACT_LEVEL",
      label: "CONTRACT_LEVEL",
    },
    {
      translate: "CONTRACT_CONTRACT_NAME",
      label: "CONTRACT_CONTRACT_NAME",
    },
  ];

  constructor(
    public _httpClient: HttpClient,
    private router: Router,
  ) {}

  async getList(defRet: any = []): Promise<any> {
    return this._httpClient
      .get(this.baseUrl)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return defRet;
      });
  }

  async getForAssets(defRet: any = []): Promise<any> {
    return this._httpClient
      .get("/asset/document")
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return defRet;
      });
  }

  async getMyDocuments() {
    return this._httpClient
      .get("/me/document")
      .toPromise()
      .then((response: IDocument[]) => {
        this.myDocumentList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async getDocument(id: number) {
    return this._httpClient.get(this.baseUrl + "/" + id).toPromise();
  }

  async getUserDocument(id: number, data: any) {
    return this._httpClient
      .post("/document-user/" + id, data)
      .toPromise()
      .catch(async (err: any) => {
        if (err === "Not found") {
          await this.router.navigateByUrl("/dashboard/main");
        }
        console.error(err);
        return err;
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseUrl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        this.list = response;
        return response;
      });
  }

  async create(data: any = []) {
    return this._httpClient
      .post(this.baseUrl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async createFile(data: any, id: string) {
    return this._httpClient
      .post("/document/" + id + "/create-file", data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async updateFile(data: any, id: string) {
    return this._httpClient
      .put("/document/" + id + "/create-file", data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: any = {}) {
    return this._httpClient.put(this.baseUrl + "/" + id, data).toPromise();
  }

  async updateUserDocument(id: number, data: any = {}, status: string = "") {
    return this._httpClient.put("/document-user" + "/" + id + status, data).toPromise();
  }

  async setRead(notifications: any = []) {
    return this._httpClient
      .post(this.baseUrl + "/set-read", { notifications })
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  //Chiamate per le cateogrie dei documenti
  async getCategoriesList() {
    return this._httpClient
      .get(this.baseurlCategories)
      .toPromise()
      .then((response: IDocumentCategory[]) => {
        this.categoriesList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async deleteCategory(id: number) {
    return this._httpClient
      .delete(this.baseurlCategories + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getCategoriesList();
        this.categoriesList = response;
        return response;
      });
  }

  async createCategory(data: any = {}) {
    return this._httpClient
      .post(this.baseurlCategories, data)
      .toPromise()
      .then(async (response) => {
        await this.getCategoriesList();
        return response;
      });
  }

  async updateCategory(id: number, data: any = {}) {
    return this._httpClient
      .put(this.baseurlCategories + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getCategoriesList();
      });
  }

  async upload_file_document(file: any, id: any) {
    return this._httpClient.post(`${this.baseUrl}/${id}/upload-file`, { file }).toPromise();
  }

  async send_signed_document(file: any, id: any) {
    return this._httpClient.put(`/document/${id}/signed-file`, { file }).toPromise();
  }
}
